
if ($('.optical-random-id').length) {
    $('#AddToCart').attr('data-line-property-id', Math.floor(Math.random() * 9999999 + 1));
}

$(document).on('change', '#frameCase', function () {
    if ($(this).is(':checked')) {
        $('#AddToCart').attr('data-include-frame-case', true);
        $('#buyItNowBtn').attr('data-include-frame-case', true);
    } else {
        $('#AddToCart').attr('data-include-frame-case', false);
        $('#buyItNowBtn').attr('data-include-frame-case', false);
    }
    // Final Sale frame label follows the case: with case = FINAL SALE, without = CASE NOT INCLUDED
    if (String($('#AddToCart').attr('data-line-property-frame')).indexOf('FINAL SALE') === 0) {
        const frameLabel = $(this).is(':checked') ? 'FINAL SALE' : 'FINAL SALE (CASE NOT INCLUDED)';
        $('#AddToCart').attr('data-line-property-frame', frameLabel);
        $('#buyItNowBtn').attr('data-line-property-frame', frameLabel);
    }
    //console.log('frameCase changed');
});



